import { inHTMLData } from 'xss-filters'
import { parse, stringify } from 'qs'
import urlUtil from 'url'
import { pick } from 'shared/utils/objectUtils'

export const TRACKING_DATA_KEYS = [
  'eventName',
  'eventType',
  'objectIDs',
  'position',
  'query',
  'queryID'
]

const safelyRetrieveParams = param => (param ? inHTMLData(param) : undefined)
const parseObjectIDs = objectIDs => objectIDs?.replace(/[^\d,]/g, '').split(',')

/**
 * Checks if at least one tracking parameter is present and tracking should be added to variants URLs
 * @param {object} trackingData
 */
const checkIfTrackingDataIsValid = trackingData =>
  trackingData && Object.values(trackingData).some(Boolean)

/**
 * Retrieves algoliatracking data from product URL
 * @param {string} url - product URL
 */
export const getTrackingDataFromURL = url => {
  const { query } = urlUtil.parse(url)
  const {
    eventName,
    eventType,
    objectIDs,
    position,
    query: searchQuery,
    queryID
  } = parse(query)
  return {
    eventName: safelyRetrieveParams(eventName),
    eventType: safelyRetrieveParams(eventType),
    objectIDs: parseObjectIDs(objectIDs),
    position: safelyRetrieveParams(position),
    query: safelyRetrieveParams(searchQuery),
    queryID: safelyRetrieveParams(queryID)
  }
}

/**
 * Stringifies trackingData object into query params of the variant
 * @param {object} trackingData
 */
export const mapTrackingDataToQueryParams = trackingData =>
  checkIfTrackingDataIsValid(trackingData)
    ? `?${stringify({
        ...pick(trackingData, TRACKING_DATA_KEYS),
        objectIDs: `[${trackingData.objectIDs?.toString() || ''}]`
      })}`
    : ''

/**
 * Changes the objectIDs param in tracking data to corresponding variant ID
 * @param {string} variantId - variant product PZN or ID (same thing)
 * @param {object} trackingData
 */
export const getVariantTrackingData = (variantId, trackingData) =>
  trackingData.objectIDs && variantId
    ? { ...trackingData, objectIDs: [variantId] }
    : trackingData
